define([
	"jquery",
	"underscore",
	"marionette",
	"google_analytics",
	"forms/deposit/deposit_payme_form",
	"behaviors/form_errors_behavior",
	"backbone.syphon"
], function($, _, Marionette, GoogleAnalytics, DepositPayMeForm, FormErrorsBehavior) {
	return Marionette.View.extend({
		el: '#content_layout',

		behaviors: {
			formErrors: {
				behaviorClass: FormErrorsBehavior
			}
		},

		ui: {
			'deposit':'#deposit_btn',
			'currencySelect':'#currency_abbr',
			'amount' : '#amount',
        },

		events:{
			'click @ui.deposit': 'submitDeposit',
			'keyup @ui.amount': 'updateExpected',
		},

		initialize: function(){
			this.bindUIElements();

			if(window.lang === 'vi_VN')
			{
				GoogleAnalytics.sendGaPageviewEvent(GoogleAnalytics.googleAnalyticsUrls.payme_step1_vn);
			}
		},

		updateExpected : function() {
			const amount = $('#amount').val();
			const fx_rate = window.fx_rates;
			const amountUsd = (amount * fx_rate).toFixed(2);
			$('#expected_amount').text(`$ ${amountUsd}`);
		},

		submitDeposit: function(e) {
			e.preventDefault();

			this.triggerMethod('hide:errors');

			var formData = Backbone.Syphon.serialize(this.$('#form_submit')[0]);
			var form = new DepositPayMeForm();
			form.set(formData);

			var errors = form.validate();

			var that = this;
			if(_.size(errors) < 1){
              $('#holdon-overlay').css("display", "");

              form.validateWithServer({
					type: 'POST',
					success: function(model, res){
						that.$('#form_submit').submit();
					},
					error: function(model, error){
                      $('#holdon-overlay').css("display", "none");
                      that.triggerMethod('show:errors', error.responseJSON);
					}
				});
			}else{
				this.triggerMethod('show:errors', errors);
			}
		}
	});
});
